/* eslint-disable consistent-return */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types,no-use-before-define */
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from 'yup';
import get from 'lodash/get';
import { Box, Button, Typography, Checkbox, useMediaQuery } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import T from 'i18n-react';

import { getLSItem } from 'util/localStorageProvider';
import icwLogo from 'assets/img/qmas_logo_small_words.png';
import icwLogoWhite from 'assets/img/icw-logo-white.png';
// eslint-disable-next-line import/extensions
import loginStyles from 'assets/jss/icw/loginStyle.jsx';
import { TextField } from 'icw-components/InputFields';
import { LOCKED_LOGIN_TIME, LINKEDIN_PATHNAME_TYPES } from 'shared/constants';
import { REGISTRATION_PATH, FEDEX_PATH } from 'shared/routes';
import { FACTORY_AUDIT_LANG_PATH, LOGIN_LANG_PATH } from 'shared/path';
import { getCookie, setLanguageLocale } from 'util/icwUtility';
import LinkedInButton from 'icw-components/LinkedInButton';
import Notification from 'components/Notification';
import { useTheme } from '@material-ui/styles';
import Announcement from './components/Announcement';
import { Card, Avatar } from 'antd';
import CardMetaUser from './components/CardMetaUser';
import Description from './components/Description';
import useSessionInvitation from 'modules/supplier/hooks/useSessionInvitation';

// TODO: try to optimize => do not load from init
setLanguageLocale(T, [LOGIN_LANG_PATH, FACTORY_AUDIT_LANG_PATH]);

// yup validation defined
const formYupValidation = Yup.object().shape({
  email: Yup.string()
    .required(T.translate('login.errors.emptyEmail'))
    .email(T.translate('login.errors.invalidEmailFormat')),
  password: Yup.string().required(T.translate('login.errors.emptyPassword')),
  agreeTerm: Yup.boolean().oneOf([true], T.translate('login.errors.agreeTerm')),
});

const initialValues = {
  email: '',
  password: '',
  agreeTerm: true,
};

const Login = (props) => {
  const {
    classes,
    match: {
      params: { locale },
    },
    location,
    history,
    isUserLogin,
    isAdmin,
    roleId,
    hasToken,
    onInit,
    onLogin,
    loginLoading,
    loginError,
    loginLocked,
    unLocked,
    onSocialLogin,
    onActivateUser,
    onLogout,
    isAli,
  } = props;
  const formEl = useRef(null);
  const [focusInput, setFocusInput] = useState(false);
  const [notification, setNotification] = useState({ type: null, message: null });
  const lockedStorage = getLSItem('lockedLogin');
  const lockedTimeStorage = parseInt(getLSItem('lockedLoginTime') || 0, 10);
  const nowTime = new Date().getTime();
  const isLockedStorage =
    lockedStorage === 'true' && nowTime - lockedTimeStorage < LOCKED_LOGIN_TIME;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const sessionInvitation = useSessionInvitation();
  useEffect(() => {
    if (isUserLogin) {
      history.replace(isAli ? '/test-plan' : '/');
    }

    onInit();
    activateUser();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    let unLockedTimeout = null;
    if (!loginLoading) {
      setFocusInput(false);
      if (loginLocked) {
        unLockedTimeout = setTimeout(() => {
          unLocked();
        }, 15 * 1000 * 60);
      }
    }
    return () => {
      if (unLockedTimeout) {
        clearTimeout(unLockedTimeout);
      }
    };

    // eslint-disable-next-line
  }, [loginLoading]);

  const handleActivateSuccessfully = () =>
    setNotification({
      type: 'green_success',
      message: T.translate('login.notifications.activate_successfully'),
    });

  const handleActivateFailed = () =>
    setNotification({
      type: 'error',
      message: T.translate('login.notifications.activate_failed'),
    });

  const activateUser = () => {
    const params = queryString.parse(location.search);
    const { token, companyId } = params;

    if (token && companyId) {
      // if user logged in, need to logout first
      if (hasToken) {
        onLogout();
      }
      onActivateUser({ token, companyId }, handleActivateSuccessfully, handleActivateFailed);
    }
  };

  const isUserLoginDOM = () => {
    const params = queryString.parse(location.search);
    const { action } = params;

    if (isAdmin) {
      if (roleId === 3) {
        // eslint-disable-next-line no-undef
        return (window.location.href = '/icw_admin');
      }
      // eslint-disable-next-line no-undef
      return (window.location.href = '/admin_panel');

      // eslint-disable-next-line no-undef
    }
    if (params.redirect) {
      window.location.href = params.redirect;
    } else {
      if (action && action === 'fedex') {
        return <Redirect to={FEDEX_PATH} />;
      }
      return <Redirect to={isAli ? '/test-plan' : '/'} />;
    }
  };

  const handleLinkedinLogin = (linkedinInfo) => {
    const socialUserId = get(linkedinInfo, 'id');
    const email = get(linkedinInfo, 'email');

    onSocialLogin({ email, socialUserId });
  };

  // Form render function, formProps is all props of form object
  const renderForm = (formProps) => {
    // handleSubmit is form submit function
    // values is object to contain all value of all form fields
    // handleChange is function of Formik, it will change form field value base on name of form field
    // setFieldTouched is function of Formik, it will set touched of focusing field is false, to help us hide message of focusing field
    // errors is error object of Formik, we use it to know which field has error
    // touched to defined which field is touched, it will be true after end user clicked submit button
    // Will have more attribute of formProps, we will dicover later
    const { handleSubmit, values, handleChange, errors, setFieldTouched, touched } = formProps;

    return (
      <form onSubmit={handleSubmit} className={classes.loginContainer}>
        <h3 className={classes.title}>
          {sessionInvitation.from === 'invitation'
            ? 'Accept Buyer Invitation'
            : T.translate('login.login')}
        </h3>
        {sessionInvitation.from !== 'invitation' && (
          <>
            <LinkedInButton
              pathname={LINKEDIN_PATHNAME_TYPES.login}
              title={T.translate('login.linkedIn')}
              onSuccess={handleLinkedinLogin}
            />
            <Typography className={classes.orTitle}>{T.translate('login.orTitle')}</Typography>
          </>
        )}

        {sessionInvitation.from !== 'invitation' ? (
          <TextField
            fullWidth
            autoFocus
            name="email"
            storeName="general"
            value={values.email}
            onChange={(e) => {
              handleChange(e);
              setFocusInput(true);
            }}
            margin="normal"
            error={touched.email && !!errors.email}
            helperText={touched.email && errors.email}
            setFieldTouched={setFieldTouched}
            style={{ paddingTop: '10px', paddingBottom: '10px' }}
            className={classes.textFieldCustom}
          />
        ) : (
          <>
            <Description>
              Please enter password to begin co-operating with{' '}
              <b>{sessionInvitation.companyName}</b>
            </Description>
            <CardMetaUser email={sessionInvitation.email}></CardMetaUser>
          </>
        )}

        <TextField
          fullWidth
          name="password"
          storeName="general"
          type="password"
          value={values.password}
          onChange={(e) => {
            handleChange(e);
            setFocusInput(true);
          }}
          margin="normal"
          error={touched.password && !!errors.password}
          helperText={touched.password && errors.password}
          setFieldTouched={setFieldTouched}
          usingShowPassword
          hideCheckIcon
          style={{ paddingTop: 10, paddingBottom: 10, marginTop: 12 }}
          className={classes.textFieldCustom}
        />
        <Typography
          className={classes.forgotPasswordText}
          onClick={() =>
            history.push({
              pathname: `/${locale}/reset-password`,
            })
          }>
          {T.translate('login.forgotPassword')}
        </Typography>
        <Box display="flex" alignItems="center">
          <Checkbox
            classes={{ root: classes.checkbox }}
            name="agreeTerm"
            onChange={(e) => {
              handleChange(e);
              setFocusInput(true);
            }}
            checked={values.agreeTerm}
            error={touched.agreeTerm && !!errors.agreeTerm}
            helperText={touched.agreeTerm && errors.agreeTerm}
            setFieldTouched={setFieldTouched}
          />
          <Box
            display="flex"
            fontSize="13px"
            flexWrap="wrap"
            fontWeight="400"
            mx={1}
            color="##232B3A">
            {T.translate('login.agreement.agree')}&nbsp;
            <a
              className={classes.alink}
              target="_blank"
              href="https://icw.io/terms-conditions/"
              rel="noreferrer">
              {T.translate('login.agreement.term&Conditions')}
            </a>
            ,&nbsp;
            <a
              className={classes.alink}
              target="_blank"
              href="https://icw.io/privacy-policy/"
              rel="noreferrer">
              {T.translate('login.agreement.privacyPolicy')}
            </a>
            ,&nbsp;
            <span
              style={{
                textTransform: 'lowercase',
              }}>
              {T.translate('login.agreement.and')}
            </span>
            &nbsp;
            <a
              className={classes.alink}
              target="_blank"
              href="https://icw.io/cookie-policy/"
              rel="noreferrer">
              {T.translate('login.agreement.cookiesPolicy')}
            </a>
            .
          </Box>
        </Box>
        {(loginLocked || isLockedStorage) && (
          <Box>
            <Typography
              variant="caption"
              display="block"
              align="left"
              color="error"
              className={classes.firstParam}>
              {T.translate('login.errors.locked.message')}
            </Typography>
            <Typography variant="caption" display="block" align="left" color="error">
              {T.translate('login.errors.locked.tryAgain')}
            </Typography>
          </Box>
        )}
        <div className={classes.btnBlock}>
          <Button
            type="submit"
            fullWidth
            color="primary"
            className={classes.button}
            disabled={!!errors.agreeTerm}>
            {T.translate('general.login')}
          </Button>
        </div>
        {loginError && !loginLocked && !focusInput && (
          <Box mt="20px">
            <Typography variant="caption" display="block" align="center" color="error">
              {T.translate('login.errors.loginFailed')}
            </Typography>
          </Box>
        )}
      </form>
    );
  };

  return isUserLogin ? (
    isUserLoginDOM()
  ) : (
    <Box className={classes.login}>
      {getCookie('qmas_important_notice') && <Announcement />}
      <Box
        display="flex"
        height="100%"
        sx={{
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}>
        <Box
          display="flex"
          flexDirection="column"
          align="center"
          alignItems="center"
          mt="10px"
          flex={0.7}>
          <Box
            sx={{
              alignSelf: {
                xs: 'center',
                md: 'flex-start',
              },
              ml: {
                xs: 0,
                md: '20px',
              },
            }}>
            <a href="/">
              <img className={classes.icon} src={icwLogo} alt="logo" />
            </a>
          </Box>
          <Box
            sx={{
              minWidth: '25%',
              maxWidth: {
                xs: '85%',
                md: '75%',
              },
            }}>
            <Formik
              // Each form always have initlaValues, it will help us define first time value of form
              initialValues={{
                ...initialValues,
                email: sessionInvitation?.email,
              }}
              // connect with yup validation defined
              validationSchema={formYupValidation}
              // enableReinitialize will help form re-render if initialValues changed
              enableReinitialize
              // If end user click submit button of the form, handleSubmit will trigger, if the form is valid (it means errors object is null)
              // onSubmit will be triggered, we can get values object on this function and do some actions with it
              onSubmit={(values) => {
                if (!isLockedStorage) {
                  onLogin(values.email, values.password);
                }
              }}
              // set ref for the form, we can use formEl ref to get form information (values, errors, everything related to the form) outside Formik wrapper
              innerRef={formEl}>
              {/* map renderForm function to the form */}
              {(fmProps) => renderForm(fmProps)}
            </Formik>
          </Box>
        </Box>
        <Box className={classes.loginBackgroundContainer}>
          <Typography className={classes.loginRightTitle}>
            {T.translate('general.newHere')}
          </Typography>
          {isMobile ? (
            <Typography className={classes.loginRightSubTitle}>
              <span
                onClick={() =>
                  history.push({
                    pathname: `/${locale}${REGISTRATION_PATH}`,
                  })
                }
                style={{
                  color: '#B0D400',
                  textDecoration: 'underline',
                }}>
                {T.translate('general.loginRightSubTitlePart1')}
              </span>
              {T.translate('general.loginRightSubTitlePart2')}
            </Typography>
          ) : (
            <Typography className={classes.loginRightSubTitle}>
              {T.translate('general.loginRightSubTitle')}
            </Typography>
          )}
          <Button
            onClick={() =>
              history.push({
                pathname: `/${locale}${REGISTRATION_PATH}`,
              })
            }
            variant="outlined"
            className={classes.loginRightButton}>
            {T.translate('login.signUp')}
          </Button>
          {isMobile && (
            <Box mt="20px">
              <img style={{ width: 42, height: 25 }} src={icwLogoWhite} alt="icwLogo" />
            </Box>
          )}
        </Box>
      </Box>
      {!isMobile && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 25,
            right: 30,
          }}>
          <Typography
            style={{ fontSize: 11, fontFamily: 'Montserrat', fontWeight: 500, color: '#fff' }}>
            Powered by
          </Typography>
          <img style={{ width: 85, height: 50 }} src={icwLogoWhite} alt="icwLogo" />
        </Box>
      )}
      <Notification
        notification={notification}
        onClose={() => setNotification({ type: null, message: null })}
      />
    </Box>
  );
};

Login.defaultProps = {
  roleId: 0,
};

Login.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
  onInit: PropTypes.func.isRequired,
  unLocked: PropTypes.func.isRequired,
  isUserLogin: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  loginLoading: PropTypes.bool.isRequired,
  loginLocked: PropTypes.bool.isRequired,
  loginError: PropTypes.string.isRequired,
  roleId: PropTypes.number,
};

export default withStyles(loginStyles)(Login);
